import React from 'react';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

import { Enrollment } from './models/Enrollment';
import { Button } from '@mui/material';
import TopNavActions from './TopNavActions';
import ConfirmExitDialog from './ConfirmExitDialog';

interface EligibleStudiesViewProps {
  enrollment: Enrollment;
  onPageChange: (page: string) => void;
}

const EligibleStudiesView: React.FC<EligibleStudiesViewProps> = ({ enrollment, onPageChange }) => {
  const [openExitDialog, setOpenExitDialog] = React.useState(false);
  const imagePath = '/assets/images/Humaaans Study Online.png';
  const { t } = useTranslation('enrollment');

  const handleFinish = () => {
    onPageChange && onPageChange('finish');
  };

  const handleBack = () => {
    onPageChange && onPageChange('back');
  };

  const handleIamNotInterested = () => {
    onPageChange && onPageChange('not-interested-thank-you-view');
  };

  const handleIamInterested = () => {
    onPageChange && onPageChange('how-did-you-learn-about-this-study-view');
  };

  const hasEligibleStudies = enrollment && enrollment.eligibleStudies && enrollment.eligibleStudies.length > 0;

  return (
    <React.Fragment>
      <TopNavActions
        onBack={handleBack}
        onExit={() => setOpenExitDialog(true)}
      />
      <ConfirmExitDialog
        open={openExitDialog}
        onClose={() => setOpenExitDialog(false)}
        onExit={() => { window.location.href = '/'; }}
      />

      <Typography variant="h4" component='h1' id="page-heading" tabIndex={-1}>{t("Eligible Studies")}</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        {enrollment?.isControlParticipant
          ? <Trans i18nKey="Based on the answers provided, you may be eligible to participate as a control!" ns="enrollment" />
          : t("Based on the answers provided, you are eligible for the following studies:")}
      </Typography>

      {!enrollment?.isControlParticipant && (
        <List>
          {enrollment?.eligibleStudies?.map((item, idx) => (
            <ListItem key={item} disablePadding>
              <ListItemText primary={`${idx + 1}. ${t(item)}`} />
            </ListItem>
          ))}
        </List>
      )}

      {hasEligibleStudies ? (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 100, marginTop: 32, marginBottom: 32 }}>
          <Button variant="outlined" onClick={handleIamNotInterested}
            style={{
              borderColor: 'var(--mui-palette-error-main)',
              color: 'var(--mui-palette-error-main)'
            }}
          >
            {t("I am not Interested")}
          </Button>
          <Button variant="contained" onClick={handleIamInterested}>
            {t("I am Interested")}
          </Button>
        </div>
      ) : (
        <Button variant="contained" onClick={handleFinish} style={{ marginTop: 32, marginBottom: 32 }}>
          {t("Finish")}
        </Button>
      )}
      <img src={imagePath} alt="Eligible studies" style={{ width: 'auto', maxHeight: '360px', display: 'block', margin: '32px auto'  }} />
    </React.Fragment>
  );
}

export default EligibleStudiesView;
